/* tslint:disable */
/* eslint-disable */
/**
 * Scania Configurator
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { GuidedViewMenuLeafNode } from './GuidedViewMenuLeafNode'
import {
  GuidedViewMenuLeafNodeFromJSON,
  GuidedViewMenuLeafNodeFromJSONTyped,
  GuidedViewMenuLeafNodeToJSON,
} from './GuidedViewMenuLeafNode'

/**
 *
 * @export
 * @interface GuidedViewMenuNode
 */
export interface GuidedViewMenuNode {
  /**
   *
   * @type {string}
   * @memberof GuidedViewMenuNode
   */
  id: string
  /**
   *
   * @type {boolean}
   * @memberof GuidedViewMenuNode
   */
  hasreadMore: boolean
  /**
   *
   * @type {string}
   * @memberof GuidedViewMenuNode
   */
  shortText: string | null
  /**
   *
   * @type {boolean}
   * @memberof GuidedViewMenuNode
   */
  isOpen: boolean
  /**
   *
   * @type {Array<GuidedViewMenuNode>}
   * @memberof GuidedViewMenuNode
   */
  subMenus?: Array<GuidedViewMenuNode> | null
  /**
   *
   * @type {Array<GuidedViewMenuLeafNode>}
   * @memberof GuidedViewMenuNode
   */
  leafItems?: Array<GuidedViewMenuLeafNode> | null
  /**
   *
   * @type {boolean}
   * @memberof GuidedViewMenuNode
   */
  hasSelectableItems: boolean
}

/**
 * Check if a given object implements the GuidedViewMenuNode interface.
 */
export function instanceOfGuidedViewMenuNode(value: object): boolean {
  let isInstance = true
  isInstance = isInstance && 'id' in value
  isInstance = isInstance && 'hasreadMore' in value
  isInstance = isInstance && 'shortText' in value
  isInstance = isInstance && 'isOpen' in value
  isInstance = isInstance && 'hasSelectableItems' in value

  return isInstance
}

export function GuidedViewMenuNodeFromJSON(json: any): GuidedViewMenuNode {
  return GuidedViewMenuNodeFromJSONTyped(json, false)
}

export function GuidedViewMenuNodeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GuidedViewMenuNode {
  if (json === undefined || json === null) {
    return json
  }
  return {
    id: json['id'],
    hasreadMore: json['hasreadMore'],
    shortText: json['shortText'],
    isOpen: json['isOpen'],
    subMenus: !exists(json, 'subMenus')
      ? undefined
      : json['subMenus'] === null
      ? null
      : (json['subMenus'] as Array<any>).map(GuidedViewMenuNodeFromJSON),
    leafItems: !exists(json, 'leafItems')
      ? undefined
      : json['leafItems'] === null
      ? null
      : (json['leafItems'] as Array<any>).map(GuidedViewMenuLeafNodeFromJSON),
    hasSelectableItems: json['hasSelectableItems'],
  }
}

export function GuidedViewMenuNodeToJSON(
  value?: GuidedViewMenuNode | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    id: value.id,
    hasreadMore: value.hasreadMore,
    shortText: value.shortText,
    isOpen: value.isOpen,
    subMenus:
      value.subMenus === undefined
        ? undefined
        : value.subMenus === null
        ? null
        : (value.subMenus as Array<any>).map(GuidedViewMenuNodeToJSON),
    leafItems:
      value.leafItems === undefined
        ? undefined
        : value.leafItems === null
        ? null
        : (value.leafItems as Array<any>).map(GuidedViewMenuLeafNodeToJSON),
    hasSelectableItems: value.hasSelectableItems,
  }
}
